import { render, staticRenderFns } from "./MerchantLayout.vue?vue&type=template&id=50daa25f&"
import script from "./MerchantLayout.vue?vue&type=script&lang=js&"
export * from "./MerchantLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantLayout.vue"
export default component.exports